module.exports = __webpack_public_path__ + "img/migrate-company.600f31a3.svg";